<template>
  <div id="scroll-board">
    <!-- 左 -->
    <div>
      <div style="width: 500px; height: 250px;">
        <dv-border-box-11 title="渠道销售占比"
          style="height: 250px;display: flex; flex-direction: column; justify-content: center">
          <div ref="pieCharts1" style="width:450px;height:290px;margin-left: 20px;margin-top: 5px;"></div>
        </dv-border-box-11>
      </div>
      <div style="width: 500px; height: 250px;margin-top: 20px;">
        <dv-border-box-11 title="售后情况"
          style="height: 250px;display: flex; flex-direction: column; justify-content: center">
          <div style="display: flex;margin-top: 60px;">
            <div style="margin-left: 60px;">
              累计金额/元
              <div style="font-weight: bold;font-size: 22px;">{{ Math.round((refundMoney + refundReturn) * 100.0) /
                100.0 }}</div>
            </div>
            <div style="margin-left: 20px;">
              退款金额/元
              <div style="font-weight: bold;font-size: 22px;">{{ refundMoney }}</div>
            </div>
            <div style="margin-left: 20px;">
              退款退货/元
              <div style="font-weight: bold;font-size: 22px;">{{ refundReturn }}</div>
            </div>
          </div>
          <div ref="pieCharts2" style="width:400px;height:240px;margin-left: 40px;margin-top: -50px;"></div>
        </dv-border-box-11>
      </div>
    </div>

    <!-- 中 -->
    <dv-border-box-10>
      <div style="width: 920px;">
        <div style="display: flex;">
          <div style="margin-left: 50px;margin-top: 100px;">
            当天下单金额：
            <div
              style="margin-top: 20px;color: #f3f70c;font-size: 24px;font-weight: bold;overflow: hidden; width: 140px">
              {{underMoney }}</div>
          </div>
          <div style="margin-left: 100px;">
            <dv-decoration-12 style="width:350px;height:350px;margin-top: 10px;">
              <div style="font-size: 20px;margin-left: 30px;">
                当天消费金额：
                <div style="margin-top: 20px; font-weight: bold;font-size: 32px;color: #f3f70c;width: 180px">
                  {{consumeMoney}}</div>
              </div>
            </dv-decoration-12>
          </div>
          <div style="margin-left: 80px;margin-top: 100px;">
            当天下单人数：
            <div style="margin-top: 20px;color: #f3f70c; font-weight: bold;font-size: 24px;width: 140px">{{underPerson}}
            </div>
          </div>
        </div>
        <div style="display: flex;margin-top: 20px;">
          <div style="margin-left: 50px;">
            累计销售金额:
            <div style="margin-top: 20px;color: #f3f70c; font-weight: bold;font-size: 24px;width: 180px">
              {{cumulativeNum}}
            </div>
          </div>
          <div style="margin-left: 180px;">
            年度销售金额:
            <div style="margin-top: 20px;color: #f3f70c; font-weight: bold;font-size: 24px;width: 140px">
              {{ yearNum}}
            </div>
          </div>
          <div style="margin-left: 160px;">
            月度销售金额:
            <div style="margin-top: 20px;color: #f3f70c; font-weight: bold;font-size: 24px;width: 140px">
              {{monthlyNum}}
            </div>
          </div>
        </div>

        <div style="display: flex;margin-top: 40px;">
          <dv-decoration-3 style="width:250px;height:30px;" />
          <dv-decoration-3 style="width:250px;height:30px;margin-left: 85px;" />
          <dv-decoration-3 style="width:250px;height:30px;margin-left: 85px;" />
        </div>
      </div>
    </dv-border-box-10>

    <!-- 右 -->
    <div>
      <div style="width: 500px; height: 250px;">
        <dv-border-box-11 title="渠道月度销售金额排名:"
          style="height: 250px; display: flex; flex-direction: column; justify-content: center">
          <dv-scroll-ranking-board :config="config1" v-if="config1.data.length > 0"
            style="width:450px;height:180px;margin-top: 60px;margin-left: 20px;" />
        </dv-border-box-11>
      </div>

      <div style="width: 500px; height: 300px;margin-top: 20px;">
        <dv-border-box-11 title="渠道年度销售金额排名:"
          style="height: 250px; display: flex; flex-direction: column; justify-content: center">
          <dv-scroll-ranking-board :config="config2" v-if="config2.data.length > 0"
            style="width:450px;height:180px;margin-top: 60px;margin-left: 20px;" />
        </dv-border-box-11>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import axios from "axios";
export default {
  name: 'ScrollBoard',
  data () {
    return {
      monthlyNum: "0.00",//月度销售金额

      yearNum: '0.00',//年度销售金额

      cumulativeNum: '0.00',//累计销售金额

      underMoney: '0.00',//下单金额
      
      underPerson: '0.00',// 下单人数
      
      consumeMoney: '0.00',// 消费金额

      refundMoney: '0.00', //退款金额

      refundReturn: '0.00',//退款退货

      // 渠道月度销售金额排名
      config1: {
        data: []
      },

      // 渠道年度销售金额排名
      config2: {
        data: []
      }
    }
  },
  mounted() {
    setInterval(this.pieCharts1, 60000);
    // 渠道销售占比
    this.pieCharts1()

    setInterval(this.pieCharts2, 60000);
    // 售后情况
    this.pieCharts2()

    setInterval(this.amount, 10000);
    // 消费金额
    this.amount()
     
    setInterval(this.monthlySales, 900000);
    // 渠道月度销售金额排名
    this.monthlySales()

    setInterval(this.yearSales, 900000);
    // 渠道年度销售金额排名
    this.yearSales()

    setInterval(this.monthlySum, 60000);
    // 月销售金额
    this.monthlySum()

    setInterval(this.yearSum, 60000);
    // 年销售金额
    this.yearSum()

    setInterval(this.cumulativeSum, 60000);
    // 累计销售金额
    this.cumulativeSum()

    setInterval(this.underMoneySum, 10000);
    // 下单金额
    this.underMoneySum()

    setInterval(this.thatDayOrdersNum, 10000);
    // 当天下单人数
    this.thatDayOrdersNum()
  },
  methods: {
    // 渠道销售占比
    pieCharts1() {
      axios.post(this.$api+"mallOrder/monthlySales").then((result) => {
        // 使用Vue的$refs来访问DOM元素
        const pieCharts1 = this.$refs.pieCharts1
        // 初始化echarts实例
        const myChart = echarts.init(pieCharts1)
        var option = {
          title: {
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              name: '渠道销售占比',
              type: 'pie',
              radius: '50%',
              data: result.data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0,0,0,0.5)'
                }
              }
            }
          ]
        }
        myChart.setOption(option)
      });
      
    },

    // 售后情况
    pieCharts2() {
      // 使用Vue的$refs来访问DOM元素
      const pieCharts2 = this.$refs.pieCharts2
      // 初始化echarts实例
      const myChart = echarts.init(pieCharts2)

      axios.post(this.$api+"mallBillRefund/refundMoneySum").then((result) => {
        this.refundMoney=result.data;
        axios.post(this.$api+"mallBillRefund/refundReturnSum").then((res) => {
          this.refundReturn = res.data;
          var option = {
            title: {
              left: 'center'
            },
            tooltip: {
              trigger: 'item'
            },
            series: [
              {
                name: '售后情况',
                type: 'pie',
                radius: '50%',
                data: [
                  { value: result.data, name: '退款金额' },
                  { value: res.data, name: '退款退货', itemStyle: { color: '#ffdc60' } }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0,0,0,0.5)'
                  }
                }
              }
            ]
          }
          myChart.setOption(option)
        });
      });
    },

    //消费金额
    amount() {
      axios.post(this.$api+"order/dayAmountSum").then((result) => {
        if (result.data != '') {
          this.consumeMoney = result.data;
        }
        
      });
    },

    // 渠道月度销售金额排名
    monthlySales() {
      axios.post(this.$api+"order/monthlySales").then((result) => {
        this.config1.data = result.data;
      });
    },
    // 渠道年度销售金额排名
    yearSales() {
      axios.post(this.$api+"order/yearSales").then((result) => {
        this.config2.data = result.data;
      });
    },
    // 月销售金额
    monthlySum() {
      axios.post(this.$api+"order/monthlySalesSum").then((result) => {
        this.monthlyNum =result.data;
      });
    },
    // 年销售金额
    yearSum() {
      axios.post(this.$api+"order/yearSalesSum").then((result) => {
        this.yearNum = result.data;
      });
    },
    // 累计销售金额
    cumulativeSum() {
      axios.post(this.$api+"order/cumulativeSum").then((result) => {
        this.cumulativeNum = result.data;
      });
    },
    //下单金额
    underMoneySum() {
      axios.post(this.$api+"order/underMoneySum").then((result) => {
        if (result.data != '') {
          this.underMoney = result.data;
        }
        
      });
    },
    // 当天下单人数
    thatDayOrdersNum() {
      axios.post(this.$api+"mallOrder/thatDayOrdersNum").then((result) => {
        if (result.data != '') {
          this.underPerson = result.data;
        }
      });
    }
  }

}
</script>

<style lang="less">
#scroll-board {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}
</style>
